export { type FooterProps, default as Footer } from './Footer';

export * from './FooterMenuGroups';
export * from './FooterLogos';
